import * as React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Greetings = styled.a`
  width: 285px;
  height: 65px;
  display: flex;
  justify-content: space-between;
  margin-top: 2px;
  background-color: #f9f9f9;
  border-radius: 1px;
  text-decoration: none;
  & :hover {
    background-color: #e0e0e0;
  }
  & .photo {
    width: 60px;
    height: 60px;
    margin: 2px;
    background-size: cover;
    background-repeat: no-repeat;
  }
  & .theme {
    display: flex;
    flex-direction: column;
    font-weight: 900;
    color: #005daa;
    width: 210px;
    height: 65px;
    & .annual {
      height: 0.8em;
      margin: 20px 0 0 10px;
      font-size: 0.8em;
      text-align: left;
    }
    & .title {
      height: 1.2em;
      text-align: left;
      margin: 10px 0 0 10px;
      font-size: 1.2em;
    }
  }
`;

const BannerLink = (props: { link: string; bannerImage: string; }) => {
  const { link, bannerImage } = props;
  const ImageWrapper = styled.div`
  background-image: url(${bannerImage});
  background-position: right 50% top 10%;
`;
const ArrowRight = styled.div`
  margin: 23px -8px 0 0;
  width: 0;
  height: 0;
  border-top: solid 10px transparent;
  border-right: solid 10px transparent;
  border-bottom: solid 10px transparent;
  border-left: solid 10px #005daa;
`;
  return (
    <Greetings href={link} target="_blank">
      <ImageWrapper className="photo"></ImageWrapper>
      <div className="theme">
        <div className="annual">2750地区</div>
        <div className="title">ガバナー挨拶</div>
      </div>
      <ArrowRight></ArrowRight>
    </Greetings>
  );
};

BannerLink.defaultProps = {
  link: '',
};

BannerLink.propTypes = {
  link: PropTypes.string,
  bannerImage: PropTypes.string,
};

export default BannerLink;
